<ng-container *transloco="let t;">

  <p-card>
    <app-reporting-table
      [type]="'observerappointments'"
    ></app-reporting-table>
  </p-card>

</ng-container>
